"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/createSuper"));

require("element-ui/lib/theme-chalk/src/base.css");

require("element-ui/lib/theme-chalk/src/form-item.css");

var _formItem2 = _interopRequireDefault(require("element-ui/lib/form-item"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

require("core-js/modules/es.object.get-own-property-descriptor.js");

require("core-js/modules/es.object.define-property.js");

require("core-js/modules/es.array.includes.js");

require("core-js/modules/es.string.trim.js");

require("core-js/modules/es.array.for-each.js");

require("core-js/modules/web.dom-collections.for-each.js");

var _vue = _interopRequireDefault(require("vue"));

var _lodash = _interopRequireDefault(require("lodash"));

var _rules2 = _interopRequireDefault(require("./rules"));

var _errorMessage = _interopRequireDefault(require("./error-message"));

var _vuePropertyDecorator = require("vue-property-decorator");

var __decorate = void 0 && (void 0).__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d; // eslint-disable-line

  if ((typeof Reflect === "undefined" ? "undefined" : (0, _typeof2["default"])(Reflect)) === 'object' && typeof Reflect.decorate === 'function') r = Reflect.decorate(decorators, target, key, desc); // eslint-disable-line
  else for (var i = decorators.length - 1; i >= 0; i--) {
      if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    } // eslint-disable-line

  return c > 3 && r && Object.defineProperty(target, key, r), r; // eslint-disable-line
};

var __metadata = void 0 && (void 0).__metadata || function (k, v) {
  if ((typeof Reflect === "undefined" ? "undefined" : (0, _typeof2["default"])(Reflect)) === 'object' && typeof Reflect.metadata === 'function') return Reflect.metadata(k, v); // eslint-disable-line
};

var ElFormItemVerifyComponent_1;
// 引用一份，解决某些环境下调用了全局Vue.mixin后再调用原FormItem下的方法会造成调用栈溢出
var ElFormItemMethods = _formItem2["default"].methods;

var ElFormItemVerifyComponent = ElFormItemVerifyComponent_1 = /*#__PURE__*/function (_Vue) {
  (0, _inherits2["default"])(ElFormItemVerifyComponent, _Vue);

  var _super = (0, _createSuper2["default"])(ElFormItemVerifyComponent);

  function ElFormItemVerifyComponent() {
    (0, _classCallCheck2["default"])(this, ElFormItemVerifyComponent);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(ElFormItemVerifyComponent, [{
    key: "onValidateMessageChanged",
    value: // watch某值并修改该值本身会额外触发一次，性能影响不大，暂不做过滤了。后期可能会用其它方式拦截
    function onValidateMessageChanged(msg) {
      if (this._verify && msg !== '') {
        var alias = this.alias || this.label || '该输入项';
        this.validateMessage = _errorMessage["default"].macroToValue(this.validateMessage, 'alias', alias);
      }
    }
  }, {
    key: "onWatchChanged",
    value: function onWatchChanged() {
      if (this._verify) {
        this.validate('');
      }
    }
  }, {
    key: "_verify",
    get: function get() {
      return this.verify !== undefined && this.prop;
    }
  }, {
    key: "getRules",
    value: function getRules() {
      var _this = this;

      if (!this._verify) {
        return ElFormItemMethods.getRules.apply(this, arguments);
      }

      var asyncVerifyRules = ElFormItemMethods.getRules.apply(this, arguments) || []; // 空检测

      var fieldValue = this.fieldValue; // eslint-disable-line

      fieldValue = [undefined, null].includes(fieldValue) ? '' : fieldValue + '';

      if (this.space === undefined) {
        fieldValue = fieldValue.trim();
      } // 合并普通规则


      var ruleGetters = (0, _rules2["default"])();
      var normalRules = []; // 支持原始rule 風格
      // 添加验证规则;

      _lodash["default"].forEach(asyncVerifyRules, function (rule, index) {
        if (_lodash["default"].isArray(rule)) {
          _lodash["default"].forEach(rule, function (item) {
            normalRules.push(item);
          });
        } else if (_lodash["default"].isString(rule) && ruleGetters[rule]) {
          var _rules = ruleGetters[rule](true, _this.elForm, _this);

          if (_lodash["default"].isArray(_rules)) {
            _lodash["default"].forEach(_rules, function (item) {
              normalRules.push(item);
            });
          } else {
            normalRules.push(_rules);
          }
        } else if (_lodash["default"].isPlainObject(rule)) {
          for (var pro in rule) {
            if (rule.hasOwnProperty(pro) && ruleGetters[pro]) {
              var ruleValid = ruleGetters[pro](rule[pro], _this.elForm, _this);

              if (_lodash["default"].isArray(ruleValid)) {
                _lodash["default"].forEach(ruleValid, function (item) {
                  normalRules.push(item);
                });
              } else {
                normalRules.push(ruleValid);
              }
            }
          }
        }
      });

      asyncVerifyRules = normalRules; // 自定义校验方法置后

      if (typeof this.verify === 'function') {
        asyncVerifyRules.push({
          validator: this.verify
        });
      } // 当规则为空时，返回一个始终通过的规则来避免空检测错误无法清除
      // 也可以通过(this as any).clearValidate()的方式实现，不过不太好


      if (asyncVerifyRules.length === 0) {
        asyncVerifyRules.push({
          validator: function validator(rule, val, callback) {
            callback();
          }
        });
      } // }


      return asyncVerifyRules;
    } // 兼容<2.0.0-beta.1

  }, {
    key: "clearValidate",
    value: function clearValidate() {
      if (ElFormItemMethods.clearValidate) {
        ElFormItemMethods.clearValidate.apply(this, arguments);
      } else {
        this.validateState = '';
        this.validateMessage = '';
        this.validateDisabled = false;
      }
    }
  }, {
    key: "onFieldChange",
    value: function onFieldChange() {
      var fieldChange = this.fieldChange || ElFormItemVerifyComponent_1.fieldChange;

      if (!this._verify || fieldChange !== 'clear') {
        ElFormItemMethods.onFieldChange.apply(this, arguments);
      } else if (this._verify && fieldChange === 'clear') {
        this.clearValidate();
      }
    }
  }]);
  return ElFormItemVerifyComponent;
}(_vue["default"]);

__decorate([(0, _vuePropertyDecorator.Prop)([String, Function]), __metadata('design:type', Object)], ElFormItemVerifyComponent.prototype, 'verify', void 0);

__decorate([(0, _vuePropertyDecorator.Prop)(), __metadata('design:type', String)], ElFormItemVerifyComponent.prototype, 'canBeEmpty', void 0);

__decorate([(0, _vuePropertyDecorator.Prop)(), __metadata('design:type', String)], ElFormItemVerifyComponent.prototype, 'space', void 0);

__decorate([(0, _vuePropertyDecorator.Prop)(), __metadata('design:type', String)], ElFormItemVerifyComponent.prototype, 'emptyMessage', void 0);

__decorate([(0, _vuePropertyDecorator.Prop)(), __metadata('design:type', String)], ElFormItemVerifyComponent.prototype, 'errorMessage', void 0);

__decorate([(0, _vuePropertyDecorator.Prop)(), __metadata('design:type', String)], ElFormItemVerifyComponent.prototype, 'alias', void 0);

__decorate([(0, _vuePropertyDecorator.Prop)(), __metadata('design:type', void 0)], ElFormItemVerifyComponent.prototype, 'watch', void 0);

__decorate([(0, _vuePropertyDecorator.Prop)(), __metadata('design:type', String)], ElFormItemVerifyComponent.prototype, 'fieldChange', void 0);

__decorate([(0, _vuePropertyDecorator.Watch)('validateMessage'), __metadata('design:type', Function), __metadata('design:paramtypes', [String]), __metadata('design:returntype', void 0)], ElFormItemVerifyComponent.prototype, 'onValidateMessageChanged', null);

__decorate([(0, _vuePropertyDecorator.Watch)('watch'), __metadata('design:type', Function), __metadata('design:paramtypes', []), __metadata('design:returntype', void 0)], ElFormItemVerifyComponent.prototype, 'onWatchChanged', null);

ElFormItemVerifyComponent = ElFormItemVerifyComponent_1 = __decorate([_vuePropertyDecorator.Component], ElFormItemVerifyComponent);
var _default = ElFormItemVerifyComponent;
exports["default"] = _default;